import { Utils } from '@genial/utils';

import { DirectTreasuryDetailsModalComponentsProps } from '../..';

export const directTreasuryDetailTexts = {
  initial: (item: DirectTreasuryDetailsModalComponentsProps['item']) =>
    `Ativo com rentabilidade atrelada à taxa ${item.rateIncome} + ${Utils.Mask.Percentage(
      item.purchaseRate
    )} ao ano.`,
  middle: (item: DirectTreasuryDetailsModalComponentsProps['item']) =>
    `Investimento a partir de ${Utils.Mask.Money(
      item.minimumApplication
    )}, mas você pode fracionar o valor da aplicação.`,
  end: (item: DirectTreasuryDetailsModalComponentsProps['item']) =>
    `O resgate pode ser feito a qualquer momento, com vencimento em ${Utils.Mask.DateFormat(
      item.maturityDate!,
      "LLLL 'de' yyyy"
    )}.`,
};
